module.exports = __webpack_public_path__ + "static/thinking-in-pictures-expanded-edition-9e619b8262c54ee57212e81e871de963.jpg";